import React, { useEffect, useState } from 'react'
import { useChangeSupplierStatusMutation, useCreateSupplierMutation, useDeleteSupplierMutation, useSupplierByIdQuery, useSupplierListQuery, useUpdateSupplierMutation } from '../../../Store/Apis/supplierApis'
import Loader from '../../../Components/Loader/Loader'
import Error from '../../../Components/Error/Error'
import AddEditSuplier from '../../../Components/AddEditSuplier/AddEditSuplier'
import toast from 'react-hot-toast'
import { Modal } from 'react-bootstrap'
import { isPermissionGranted } from '../../../Hooks/permissionsMiddleware'
import { Table } from 'antd'
import { useSelector } from 'react-redux'

const Suppliers = () => {
  const user = useSelector((state) => state.auth.user)
  // page 1 for listing Suppliers
  // page 2 for add Suppliers
  // page 3 for edit Suppliers
  const [page, setPage] = useState()
  const [sortFilter, setSortFilter] = useState({
    search: '',
    filter: '',
    outletID:''
  });
  const getSuppliersApi = useSupplierListQuery({
    supplierName: sortFilter.search,
    outletID: sortFilter.outletID
  })



  // STTAUS CHANGE
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [changeStatus] = useChangeSupplierStatusMutation()
  const handleChangeStatus = () => {
      changeStatus(selectedStatus).then((res)=>{
        console.log(res)
        setSelectedStatus(null)
      })
  }

  // DELETE
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [deleteCategory] = useDeleteSupplierMutation()
  const handleDelete = () => {
      deleteCategory(selectedRecord).then((res)=>{
        console.log(res)
        setSelectedRecord(null)
      })
  }



  // CREATE SUPPLIER METHODS
  const [createSupplierMutation] = useCreateSupplierMutation()
  const handleCreateSupplier = (formData) => {
    createSupplierMutation({
      supplierID: 0,
      companyName: formData.companyName,
      companyPhone: formData.companyPhone,
      contactPerson: formData.contactPersonName,
      contactPhone: formData.contactPersonPhone,
      email: formData.companyEmail,
      address: formData.address,
      city: formData.city,
      pin: formData.pin,
      outlets : formData.outlets,
      isActive: 1
    }).then((res) => {
      if (res?.data?.status === 200) {
        setPage(1)
        toast.success(res?.data?.message, { duration: 7000 });
      } else {
        toast.error(res?.data?.message, { duration: 7000 });
      }
    })
  }

  // EDIT SUPPLIER METHODS
  const [selectedEditId, setSelectedEditId] = useState()
  const supplierByIdApi = useSupplierByIdQuery({
    supplierID: selectedEditId
  }, {skip: !selectedEditId})
  const [updateSupplierMutation] = useUpdateSupplierMutation()
  const handleEditSupplier = (formData) => {
    updateSupplierMutation({
      supplierID: selectedEditId,
      companyName: formData.companyName,
      companyPhone: formData.companyPhone,
      contactPerson: formData.contactPersonName,
      contactPhone: formData.contactPersonPhone,
      email: formData.companyEmail,
      address: formData.address,
      city: formData.city,
      pin: formData.pin,
      outlets : formData.outlets,
      isActive: 1
    }).then((res) => {
      if (res?.data?.status === 200) {
        setPage(1)
        toast.success(res?.data?.message, { duration: 7000 });
      } else {
        toast.error(res?.data?.message, { duration: 7000 });
      }
    })
  }
  

  useEffect(() => {
    if (user.role !== 'superAdmin') {
      setSortFilter({
        ...sortFilter,
        outletID: user.outletID
      });
    }
  }, []);

  // ADD SUPPLIER VIEW
  if(page === 2){
    return(
      <div>
        <div className="row align-items-center justify-content-between mb-3">
          <div className="col">
            <h5 className="fw-500 text-white mb-0">Add New Suppliers</h5>
          </div>
          <div className="col-auto">
              <button 
                type='button'
                className="btn btn-icon btn-3 btn-white text-primary mb-0"
                onClick={()=> setPage(1)}
              >
                <i className="fa fa-arrow-left me-2"></i>  Back
              </button>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <AddEditSuplier handleSubmit={handleCreateSupplier} cancel={setPage}/>
          </div>
        </div>
      </div>
    )
  }

  // EDIT SUPPLIER VIEW
  if(page === 3){
    return(
      <div>
        <div className="row align-items-center justify-content-between mb-3">
          <div className="col">
            <h5 className="fw-500 text-white mb-0">Edit Supplier</h5>
          </div>
          <div className="col-auto">
              <button 
                type='button'
                className="btn btn-icon btn-3 btn-white text-primary mb-0"
                onClick={()=> setPage(1)}
              >
                <i className="fa fa-arrow-left me-2"></i>  Back
              </button>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            {supplierByIdApi.isError && <Error/>}
            {supplierByIdApi.isFetching && <Loader height="500px"/>}
            {supplierByIdApi.isLoading && <Loader height="500px"/>}
            {
              (supplierByIdApi.isSuccess && !supplierByIdApi.isFetching) && (
                <AddEditSuplier 
                  handleSubmit={handleEditSupplier} 
                  data={supplierByIdApi.isSuccess && supplierByIdApi?.data?.data[0]}
                  cancel={setPage}
                />
              )
            }
          </div>
        </div>
      </div>
    )
  }

  const dataSource = getSuppliersApi?.data?.data?.map((supplier, index) => ({
    key: supplier.id,
    index: index + 1,
    companyName: supplier.companyName,
    outlets: supplier.outlets,
    companyEmail: supplier.companyEmail,
    companyPhone: supplier.companyPhone,
    contactPerson: supplier.contactPerson,
    contactPhone: supplier.contactPhone,
    isActive: supplier.isActive,
  }));
  
  // Columns Configuration
  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'index',
      align: 'center',
    },
    {
      title: 'Company Name',
      dataIndex: 'companyName',
      key: 'companyName',
      sorter: (a, b) => a.companyName.localeCompare(b.companyName),
      render: (text) => <p className="text-wrap mb-0 fw-bold text-sm" style={{ maxWidth: '150px' }}>{text}</p>,
    },
    {
      title: 'Outlets',
      dataIndex: 'outlets',
      key: 'outlets',
      render: (outlets) => (
        <div className="text-wrap" style={{ maxWidth: 250 }}>
          {outlets.map((outlet) =>(
            outlet.isActive === 1 ? (
              <span className="badge badge-sm bg-dark rounded-pill fw-500 me-1" key={outlet.id} id={outlet.outletId}>                
                {outlet.outletName}
              </span>
            ) : null
          ))}
        </div>
      ),
    },
    {
      title: 'Company Contact',
      dataIndex: 'companyContact',
      key: 'companyContact',
      render: (_, record) => (
        <div>
          <p className="mb-0 text-sm">{record.companyEmail}</p>
          <p className="mb-0 text-sm">{record.companyPhone}</p>
        </div>
      ),
    },
    {
      title: 'Contact Person',
      dataIndex: 'contactPerson',
      key: 'contactPerson',
      render: (_, record) => (
        <div>
          <p className="text-sm mb-0">{record.contactPerson}</p>
          <p className="text-sm mb-0">{record.contactPhone}</p>
        </div>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive, record) => (
        <button
          type="button"
          className={`btn badge badge-xs ${isActive === 1 ? 'badge-success' : 'badge-danger'} fw-600 text-xs mb-0`}
          onClick={() =>
            setSelectedStatus({
              keyID: record.key,
              isActive: isActive === 1 ? 0 : 1,
            })
          }
        >
          {isActive === 1 ? 'Active' : 'Deactivated'}
        </button>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <div>
          <button
            type="button"
            onClick={() => (setPage(3), setSelectedEditId(record.key))}
            className="badge badge-xs badge-warning fw-600 text-xs btn mb-0"
          >
            Edit
          </button>
          <button
            type="button"
            className="btn ms-2 badge badge-xs badge-danger text-xs fw-600 mb-0"
            onClick={() => setSelectedRecord(record.key)}
          >
            Delete  
          </button>
        </div>
      ),
    },
  ];


  return (
    <>
      <div>
        <div className="row align-items-center justify-content-between mb-3">
          <div className="col">
            <h5 className="fw-500 text-white">Suppliers</h5>
          </div>
          {
            isPermissionGranted(27) && (
              <div className="col-auto">
                <button
                  type='button' 
                  className="btn btn-icon btn-3 btn-white text-primary mb-0"
                  onClick={()=> setPage(2)}
                >
                  <i className="fa fa-plus me-2"></i>  Add New Supplier
                </button>
              </div>
            )
          }
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card mb-4">
              <div className="card-header p-4">
                <input 
                  type="text" 
                  className="form-control" 
                  placeholder="Search by Company name" 
                  value={sortFilter?.search || ""}
                  onChange={(e) => setSortFilter({...sortFilter, search: e.target.value})}
                />
              </div>
              <div className="card-body p-0">
                {getSuppliersApi.isError && <Error/>}
                {getSuppliersApi.isLoading && <Loader height="500px"/>}
                {
                  getSuppliersApi.isSuccess && (
                    <Table
                      dataSource={dataSource}
                      columns={columns}
                      loading={getSuppliersApi.isLoading}
                      pagination={{ pageSize: 10 }}
                      rowKey={(record) => record.key}
                    />
                  )
                }
              </div>
            </div>
          </div>
        </div>


        {/* STATUS CHANGE MODAL */}
        <Modal 
            show={selectedStatus} 
            onHide={() => setSelectedStatus(null)} 
            size="sm" 
            centered
        >
            <Modal.Body className='text-center p-4'>
                <h5>Are you sure you want to change status?</h5>
                <div className="buttons d-flex gap-3 justify-content-center">
                    <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={()=>(setSelectedStatus(null))}>Cancel</button>
                    <button className='btn btn-primary btn-sm mb-0' onClick={handleChangeStatus}>Confirm</button>
                </div>
            </Modal.Body>
        </Modal>

        {/* DELETE MODAL */}
        <Modal  
            show={selectedRecord} 
            onHide={() => setSelectedRecord(null)} 
            size="sm" 
            centered
        >
            <Modal.Body className='text-center p-4'>
                <h5>Are you sure you want to delete the brand?</h5>
                <div className="buttons d-flex gap-3 justify-content-center">
                    <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={()=>(setSelectedRecord(null))}>Cancel</button>
                    <button className='btn btn-primary btn-sm mb-0' onClick={handleDelete}>Confirm</button>
                </div>
            </Modal.Body>
        </Modal>
      </div>
    </>
  )
}

export default Suppliers